var _style, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNofiles(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "610.42px",
    height: "387.01px",
    viewBox: "0 0 610.42 387.01",
    style: {
      enableBackground: "new 0 0 610.42 387.01"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#44BAC5;}\n\t.st1{fill:#222931;}\n\t.st2{fill:#45B9C5;}\n\t.st3{fill:#FFFFFF;}\n\t.st4{fill:none;}\n\t.st5{opacity:0.5882;}\n\t.st6{opacity:0.8784;}\n\t.st7{fill:#EFEEEF;}\n\t.st8{fill:#45B9C5;stroke:#000000;stroke-miterlimit:10;}\n\t.st9{fill:#FFFFFF;stroke:#000000;stroke-miterlimit:10;}\n\t.st10{fill:#222931;stroke:#222931;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M594.21,254.92v-9c0-1.1,0.9-2,2-2l0,0c1.1,0,2,0.9,2,2v9H594.21z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M594.21,270.34v-9h4v9c0,1.1-0.9,2-2,2l0,0C595.1,272.34,594.21,271.44,594.21,270.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M599.42,256.13h9c1.1,0,2,0.9,2,2l0,0c0,1.1-0.9,2-2,2h-9V256.13z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M584,256.13h9v4h-9c-1.1,0-2-0.9-2-2l0,0C582,257.03,582.9,256.13,584,256.13z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M12.21,254.92v-9c0-1.1,0.9-2,2-2h0c1.1,0,2,0.9,2,2v9H12.21z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M12.21,270.34v-9h4v9c0,1.1-0.9,2-2,2h0C13.1,272.34,12.21,271.44,12.21,270.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M17.42,256.13h9c1.1,0,2,0.9,2,2l0,0c0,1.1-0.9,2-2,2h-9V256.13z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M2,256.13h9v4H2c-1.1,0-2-0.9-2-2l0,0C0,257.03,0.9,256.13,2,256.13z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M543.77,337.47v-7.93c0-0.64,0.52-1.16,1.16-1.16h0.99c0.64,0,1.16,0.52,1.16,1.16v7.93H543.77z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M543.77,350.71v-7.93h3.31v7.93c0,0.64-0.52,1.16-1.16,1.16h-0.99 C544.29,351.87,543.77,351.35,543.77,350.71z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M548.08,338.47h7.93c0.64,0,1.16,0.52,1.16,1.16v0.99c0,0.64-0.52,1.16-1.16,1.16h-7.93V338.47z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M534.84,338.47h7.93v3.31h-7.93c-0.64,0-1.16-0.52-1.16-1.16v-0.99 C533.68,338.99,534.2,338.47,534.84,338.47z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M62.8,337.47v-7.93c0-0.64,0.52-1.16,1.16-1.16h0.99c0.64,0,1.16,0.52,1.16,1.16v7.93H62.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M62.8,350.71v-7.93h3.31v7.93c0,0.64-0.52,1.16-1.16,1.16h-0.99C63.32,351.87,62.8,351.35,62.8,350.71z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M67.11,338.47h7.93c0.64,0,1.16,0.52,1.16,1.16v0.99c0,0.64-0.52,1.16-1.16,1.16h-7.93V338.47z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M53.87,338.47h7.93v3.31h-7.93c-0.64,0-1.16-0.52-1.16-1.16v-0.99C52.72,338.99,53.23,338.47,53.87,338.47z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M527.36,64.14V56.9c0-0.64,0.52-1.16,1.16-1.16h0.74c0.64,0,1.16,0.52,1.16,1.16v7.24H527.36z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M527.36,76.28v-7.24h3.05v7.24c0,0.64-0.52,1.16-1.16,1.16h-0.74C527.87,77.44,527.36,76.92,527.36,76.28z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M531.33,65.07h7.24c0.64,0,1.16,0.52,1.16,1.16v0.74c0,0.64-0.52,1.16-1.16,1.16h-7.24V65.07z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M519.19,65.07h7.24v3.05h-7.24c-0.64,0-1.16-0.52-1.16-1.16v-0.74C518.04,65.59,518.55,65.07,519.19,65.07z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M83.04,64.14V56.9c0-0.64,0.52-1.16,1.16-1.16h0.74c0.64,0,1.16,0.52,1.16,1.16v7.24H83.04z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M83.04,76.28v-7.24h3.05v7.24c0,0.64-0.52,1.16-1.16,1.16h-0.74C83.55,77.44,83.04,76.92,83.04,76.28z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M87.01,65.07h7.24c0.64,0,1.16,0.52,1.16,1.16v0.74c0,0.64-0.52,1.16-1.16,1.16h-7.24V65.07z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M74.87,65.07h7.24v3.05h-7.24c-0.64,0-1.16-0.52-1.16-1.16v-0.74C73.72,65.59,74.23,65.07,74.87,65.07z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M488.07,127.43v-5.75c0-0.64,0.52-1.16,1.16-1.16h0.2c0.64,0,1.16,0.52,1.16,1.16v5.75H488.07z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M488.07,137.21v-5.75h2.51v5.75c0,0.64-0.52,1.16-1.16,1.16h-0.2C488.59,138.37,488.07,137.85,488.07,137.21 z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M491.34,128.18h5.75c0.64,0,1.16,0.52,1.16,1.16v0.2c0,0.64-0.52,1.16-1.16,1.16h-5.75V128.18z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M481.55,128.18h5.75v2.51h-5.75c-0.64,0-1.16-0.52-1.16-1.16v-0.2C480.4,128.7,480.92,128.18,481.55,128.18z "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M122.39,127.43v-5.75c0-0.64,0.52-1.16,1.16-1.16h0.2c0.64,0,1.16,0.52,1.16,1.16v5.75H122.39z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M122.39,137.21v-5.75h2.51v5.75c0,0.64-0.52,1.16-1.16,1.16h-0.2C122.9,138.37,122.39,137.85,122.39,137.21z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M125.66,128.18h5.75c0.64,0,1.16,0.52,1.16,1.16v0.2c0,0.64-0.52,1.16-1.16,1.16h-5.75V128.18z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M115.87,128.18h5.75v2.51h-5.75c-0.64,0-1.16-0.52-1.16-1.16v-0.2C114.72,128.7,115.23,128.18,115.87,128.18 z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M556.35,168.85v-8.26c0-0.64,0.52-1.16,1.16-1.16h1.11c0.64,0,1.16,0.52,1.16,1.16v8.26H556.35z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M556.35,182.6v-8.26h3.42v8.26c0,0.64-0.52,1.16-1.16,1.16h-1.11C556.87,183.76,556.35,183.24,556.35,182.6z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M560.81,169.88h8.26c0.64,0,1.16,0.52,1.16,1.16v1.11c0,0.64-0.52,1.16-1.16,1.16h-8.26V169.88z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M547.06,169.88h8.26v3.42h-8.26c-0.64,0-1.16-0.52-1.16-1.16v-1.11C545.9,170.4,546.42,169.88,547.06,169.88 z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M58.17,168.85v-8.26c0-0.64,0.52-1.16,1.16-1.16h1.11c0.64,0,1.16,0.52,1.16,1.16v8.26H58.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M58.17,182.6v-8.26h3.42v8.26c0,0.64-0.52,1.16-1.16,1.16h-1.11C58.68,183.76,58.17,183.24,58.17,182.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M62.62,169.88h8.26c0.64,0,1.16,0.52,1.16,1.16v1.11c0,0.64-0.52,1.16-1.16,1.16h-8.26V169.88z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M48.87,169.88h8.26v3.42h-8.26c-0.64,0-1.16-0.52-1.16-1.16v-1.11C47.72,170.4,48.23,169.88,48.87,169.88z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Layer_3"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 190.35,
    y: 327.61,
    className: "st0",
    width: 107.7,
    height: 27.89
  }), /*#__PURE__*/React.createElement("rect", {
    x: 85.35,
    y: 278.67,
    className: "st0",
    width: 230.66,
    height: 27.95
  }), /*#__PURE__*/React.createElement("rect", {
    x: 378.08,
    y: 303.64,
    className: "st0",
    width: 22,
    height: 27.95
  }), /*#__PURE__*/React.createElement("rect", {
    x: 99.35,
    y: 174.59,
    className: "st0",
    width: 278.73,
    height: 27.95
  }), /*#__PURE__*/React.createElement("rect", {
    x: 190.35,
    y: 121.59,
    className: "st0",
    width: 216,
    height: 27.95
  }), /*#__PURE__*/React.createElement("rect", {
    x: 162.42,
    y: 69.59,
    className: "st0",
    width: 268.44,
    height: 27.95
  }), /*#__PURE__*/React.createElement("rect", {
    x: 210.42,
    y: 21.59,
    className: "st0",
    width: 175.66,
    height: 27.95
  }), /*#__PURE__*/React.createElement("rect", {
    x: 472.86,
    y: 69.59,
    className: "st0",
    width: 19.81,
    height: 27.95
  }), /*#__PURE__*/React.createElement("rect", {
    x: 513.06,
    y: 199.59,
    className: "st0",
    width: 42,
    height: 27.95
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 190.35,
    cy: 341.61,
    r: 14
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 296.35,
    cy: 341.61,
    r: 14
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 85.35,
    cy: 292.61,
    r: 14
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 316.08,
    cy: 292.61,
    r: 14
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 378.08,
    cy: 317.61,
    r: 14
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M282.01,327.61c-5.72,0-10.35-4.69-10.35-10.47c0-5.78,4.63-10.47,10.35-10.47c0.12,0,0.23,0.01,0.35,0.02 v-7.55h-82.98v7.36c0.43-0.05,0.86-0.08,1.3-0.08c5.72,0,10.35,4.8,10.35,10.74c0,5.93-4.63,10.74-10.35,10.74 c-0.44,0-0.87-0.03-1.3-0.08v0.33h82.98v-0.55C282.24,327.6,282.12,327.61,282.01,327.61z"
  }))), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 400.08,
    cy: 317.61,
    r: 14
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 458.86,
    cy: 264.67,
    r: 14
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 134.42,
    cy: 241.57,
    r: 14
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M148.42,198.57v3.97c6.9,0,12.5,5.61,12.5,12.53c0,6.92-5.6,12.53-12.5,12.53v0.97h320.64v-30H148.42z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M186.57,250.17v5.42c0.12,0,0.24-0.02,0.37-0.02c6.38,0,11.55,5.17,11.55,11.55s-5.17,11.55-11.55,11.55 c-0.12,0-0.25-0.01-0.37-0.02v0.52h272v-29H186.57z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M430.86,227.81v-0.21h-1.4C429.94,227.64,430.4,227.71,430.86,227.81z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M428.41,250.64c-6.38,0-11.55-5.17-11.55-11.55c0-6.03,4.61-10.97,10.5-11.5H134.42v27.95h296.44v-5.17 C430.07,250.55,429.25,250.64,428.41,250.64z"
  })))), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 469.06,
    cy: 213.57,
    r: 15
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 513.06,
    cy: 213.57,
    r: 14
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 555.06,
    cy: 213.57,
    r: 14
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 99.35,
    cy: 188.57,
    r: 14
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 190.35,
    cy: 135.57,
    r: 14
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 162.42,
    cy: 83.57,
    r: 14
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M363.32,69.59c-5.53,0-10.01-4.48-10.01-10.01s4.48-10.01,10.01-10.01c0.26,0,0.51,0.02,0.76,0.04v-5.04 H246.62v5.01c5.36,0.19,9.64,4.59,9.64,10c0,5.41-4.28,9.82-9.64,10.01v2.93h117.46v-2.96 C363.82,69.57,363.57,69.59,363.32,69.59z"
  }))), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 210.42,
    cy: 35.57,
    r: 14
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 386.08,
    cy: 35.57,
    r: 14
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 430.86,
    cy: 83.57,
    r: 14
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 472.86,
    cy: 83.57,
    r: 14
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 492.67,
    cy: 83.57,
    r: 14
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M220.12,197.87l16.24-112.73c0.3-2.08,2.22-3.52,4.3-3.22l175.98,25.36c2.08,0.3,3.52,2.22,3.22,4.3 l-16.24,112.73c-0.3,2.08-2.22,3.52-4.3,3.22l-175.98-25.36C221.26,201.87,219.82,199.94,220.12,197.87z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M222.86,225.91V112.01c0-2.1,1.7-3.8,3.8-3.8h177.8c2.1,0,3.8,1.7,3.8,3.8v113.89c0,2.1-1.7,3.8-3.8,3.8 h-177.8C224.56,229.7,222.86,228,222.86,225.91z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M222.86,250.04V136.15c0-2.1,1.7-3.8,3.8-3.8h181.59c2.1,0,3.8,1.7,3.8,3.8v113.89c0,2.1-1.7,3.8-3.8,3.8 H226.66C224.56,253.84,222.86,252.14,222.86,250.04z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M217.8,272.41V158.52c0-2.1,1.7-3.8,3.8-3.8h186.66c2.1,0,3.8,1.7,3.8,3.8v113.89c0,2.1-1.7,3.8-3.8,3.8 H221.59C219.5,276.21,217.8,274.51,217.8,272.41z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M284.55,230.02v-29.11c0-1.75,1.42-3.16,3.16-3.16h55.68c1.75,0,3.16,1.42,3.16,3.16v29.11 c0,1.75-1.42,3.16-3.16,3.16h-55.68C285.97,233.18,284.55,231.77,284.55,230.02z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M285.12,207.86v-7.28c0-1.22,0.99-2.21,2.21-2.21h56.63c1.22,0,2.21,0.99,2.21,2.21v7.28 c0,1.22-0.99,2.21-2.21,2.21h-56.63C286.12,210.07,285.12,209.08,285.12,207.86z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M233.76,132.35l3.34-7.95c1.04-2.47,3.45-4.07,6.12-4.07h44.76c2.46,0,4.72,1.36,5.87,3.53l4.51,8.49H233.76 z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M249.61,127.83L249.61,127.83c0-1.57,1.27-2.85,2.85-2.85h27.21c1.57,0,2.85,1.27,2.85,2.85l0,0 c0,1.57-1.27,2.85-2.85,2.85h-27.21C250.89,130.68,249.61,129.4,249.61,127.83z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M308.1,83.76c-0.83-2.31-2.87-3.98-5.3-4.33l-44.3-6.38c-2.65-0.38-5.27,0.86-6.64,3.15l-4.44,7.39 l63.94,9.21L308.1,83.76z M296.3,86.07c-0.22,1.56-1.67,2.64-3.22,2.41l-26.93-3.88c-1.56-0.22-2.64-1.67-2.41-3.22 c0.22-1.56,1.67-2.64,3.22-2.41l26.93,3.88C295.45,83.07,296.53,84.52,296.3,86.07z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M233.76,109.17l3.34-8.58c1.04-2.66,3.45-4.39,6.12-4.39h44.76c2.46,0,4.72,1.46,5.87,3.81l4.51,9.16H233.76z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M249.61,103.7L249.61,103.7c0-1.57,1.27-2.85,2.85-2.85h27.21c1.57,0,2.85,1.27,2.85,2.85v0 c0,1.57-1.27,2.85-2.85,2.85h-27.21C250.89,106.54,249.61,105.27,249.61,103.7z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNofiles);
export default __webpack_public_path__ + "static/media/No files.560374b437718535c249c87ebbdcce21.svg";
export { ForwardRef as ReactComponent };